import { useEffect, useRef } from 'react'

interface Options {
    log?: boolean
    logTag?: string
}

function useArrayDiff<T>(arr: T[], comparator: (a: T, b: T) => boolean, options?: Options) {
    const prev = useRef<T[]>([])
    const state = useRef<{ added: T[]; removed: T[] }>({
        added: [],
        removed: [],
    })

    useEffect(() => {
        // Check added: if x in arr but not in prev.current.
        let added: T[] = []
        arr.forEach((a) => {
            if (prev.current.filter((b) => comparator(a, b)).length === 0) {
                added.push(a)
            }
        })

        // Check removed: if x in prev.current but not in arr.
        let removed: T[] = []
        prev.current.forEach((a) => {
            if (arr.filter((b) => comparator(a, b)).length === 0) {
                removed.push(a)
            }
        })

        if (options?.log) {
            const tag = ` (tag=${options.logTag})`
            console.log(
                `at useArrayDiff effect handler${tag}:\n arr=%O\n prev=%O\n added=%O\n removed=%O`,
                arr,
                prev.current,
                added,
                removed
            )
        }

        prev.current = arr
        state.current.added = added
        state.current.removed = removed
    }, [arr])

    return state.current
}

export default useArrayDiff
